<template>
  <div :class="$style.container">
    <div
      v-if="getImage"
      :class="$style.overlay"
      :style="{ backgroundImage: `url(${getImage})` }"
    />
    <component
      v-else
      :is="getDefaultImage"
      v-fill:black
      v-opacity=".2"
    />
  </div>
</template>

<script>
export default {
  name: 'BillImageCard',
  props: {
    bill: {
      type: Object,
      required: true,
    },
  },
  computed: {
    getImage() {
      return this.bill.billImageLink;
    },
    getDefaultImage() {
      if (this.bill.isDonate) {
        return () => import('atoms/icons/custom/ThumbsUp');
      }

      return () => import('atoms/icons/custom/Planet');
    },
  },
};
</script>

<style lang="sass" module>
  .container
    +size(auto, 140px)
    display: flex
    justify-content: center
    align-items: center
    background: linear-gradient(249.76deg, #37B55E -8.32%, #7BD3FF 108.85%), #FFFFFF

    +respond-to(medium)
      +size(auto, 220px)

  .overlay
    +covered-image
</style>
